import { speed } from 'jquery';
import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'

var indexBanner = new Swiper(".index-banner .mySwiper", {
    loop:true,
    speed:1500,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
     pagination: {
        el: ".index-banner .swiper-pagination",
   
        clickable: true,
        renderBullet: function (index, className) {
            return `<span class="${className}"> <i>Part</i>  <i>0${index + 1}</i></span>`;
        }
    },
});
var productSwiper = new Swiper(".section1 .mySwiper", {
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev"
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.923%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    } 
});

var slides1 = document.querySelectorAll('.section1 .swiper .swiper-slide');
var maxHeight = 0;
slides1.forEach(function(slide) {
    slide.style.height = ''; // 重置高度，以便重新计算最大高度
    var height = slide.offsetHeight; // 获取当前滑块的高度
    if (height > maxHeight) {
    maxHeight = height; // 更新最大高度值
    }
});
slides1.forEach(function(slide) {
    slide.style.height = maxHeight + 'px'; // 设置所有滑块的高度为最大高度值
});


$(".product-nav a").eq(0).addClass("active");
$(".product-list .content").eq(0).addClass("active");
$(".product-nav a").click(function() {
  let index = $(this).index();
  $(this).addClass("active").siblings().removeClass("active");
  $(".product-list .content").eq(index).addClass("active").siblings().removeClass("active");
}) 

var wrapTop = $(".index .product-nav").offset().top;
var istrue = true;
$(window).on("scroll",
function() {
    var s = $(window).scrollTop();
    if (s > wrapTop  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

var section4 = new Swiper(".section4 .mySwiper", {
    slidesPerView: 4,
    spaceBetween: 20,
    centeredSlides: true,
    loop:true,
    speed: 3000,
    autoplay: {
      delay: 0,   //每循环一圈，间隔时间，无缝轮询，则为0
      stopOnLastSlide: false,
    },
    breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        spaceBetween: 20,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
         slidesPerView: 2,
          spaceBetween: 20,
      }
    } 
});


$(".section7 ul li").eq(2).addClass("active");
$(".section7 .text p").eq(2).addClass("active");

let counter = 0;
let currentPosition = 0;
// 保存原始列表状态
const originalList = $('#myList').html();

// 更新第三个位置的信息
function updateThirdPositionInfo() {
    const thirdItem = $('#myList li:nth-child(3)').find('.item-content').text();
    $('#currentThird').text(thirdItem);
}

// 更新active项信息
function updateActiveItemInfo() {
    const activeItem = $('#myList li.active').find('.item-content').text();
    $('#activeItem').text(activeItem || '无');
}

// 更新指示器状态
function updateIndicators() {
    $('.indicator').removeClass('active');
    $(`.indicator[data-index="${currentPosition}"]`).addClass('active');
}

// 移动轮播图
function moveCarousel() {
    const translateX = -currentPosition * 20;
    $('#myList').css('transform', `translateX(${translateX}%)`);
    updateIndicators();
}

// 为所有li元素添加点击事件
$('#myList').on('click', 'li', function() {
    // 移除所有li元素的active类名
    $('#myList li').removeClass('active');
    
    // 获取被点击的li元素
    const clickedItem = $(this);
    
    const index = $(this).index();
  
    const clickText = $(".section7 .text p").eq(index);

    clickText.addClass("active").siblings().removeClass("active");

    // 添加active类名到当前元素
    clickedItem.addClass('active');
    
    // 使用动画效果：先缩小，然后移动位置，最后恢复
    clickedItem.animate({
        opacity: 0.5,
        transform: 'scale(0.9)'
    }, 300, function() {
        // 从DOM中移除该元素
        const detachedItem = $(this).detach();

        clickText.remove();
        
        // 获取当前所有li元素
        const listItems = $('#myList li');

        const textItems =  $(".section7 .text p")
        
        // 如果列表项数量足够，插入到第三个位置
        if (listItems.length >= 2) {
            // 插入到第三个位置（索引2）
            $(listItems[2]).before(detachedItem);
        } else {
            // 如果列表项太少，直接添加到末尾
            $('#myList').append(detachedItem);
        }
        if (textItems.length >= 2) {
            // 插入到第三个位置（索引2）
            $(textItems[2]).before(clickText);
        } else {
            // 如果列表项太少，直接添加到末尾
            $(".section7 .text").append(clickText);
        }
        
        // 恢复样式
        detachedItem.css({
            opacity: 1,
            transform: 'scale(1)'
        });
        
        // 更新计数器
        counter++;
        $('#counter').text(counter);
        
        // 更新位置信息
        updateThirdPositionInfo();
        updateActiveItemInfo();
    });
});

var swiper7 = new Swiper(".section7 .swiper", {
    slidesPerView: 'auto', // 根据内容自动适应数量，并启用以下配置：
    centeredSlides: true, // 使幻灯片居中显示
    spaceBetween: 30, // 幻灯片之间的间距
    loop:true,
    breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 5,
        spaceBetween: '3.64%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 4,
        spaceBetween: '3.64%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: '3.64%',
      }
    } 
});


var swiper9 = new Swiper(".section9 .swiper", {
    slidesPerView: 5,
    spaceBetween: '3.64%',
    loop:true,
    speed:1000,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 5,
        spaceBetween: '3.64%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 4,
        spaceBetween: '3.64%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: '3.64%',
      }
    } 
});

var messagePic = new Swiper(".section10 .pic", {
    
});
var message = new Swiper(".section10 .mySwiper", {
    navigation: {
    nextEl: ".swiper-control .swiper-button-next",
    prevEl: ".swiper-control .swiper-button-prev",
    },
    thumbs: {
        swiper: messagePic,
    },
});